import React, { useState } from 'react'
import { Form, Button, Container, Row, Col, Alert } from 'react-bootstrap'
import { useNavigate, useLocation } from 'react-router-dom'
import { locationAPI } from '../api/locationAPI'
import { formatErrorResponse } from '../utils/errorHandlers'

function LocationCreateScreen() {
    const navigate = useNavigate()
    const { state } = useLocation();
    const warehouseId = state?.warehouseId;
    const warehouseName = state?.warehouseName;
    
    const [formData, setFormData] = useState({
        name: '',
        description: '',
        warehouse: warehouseId,
        is_active: true
    })

    const [error, setError] = useState(null)

    const handleSubmit = async (e) => {
        e.preventDefault()
        try {
            await locationAPI.create(formData)
            navigate(-1)
        } catch (error) {
            setError(formatErrorResponse(error))
        }
    }

    const handleChange = (e) => {
        const { name, value } = e.target
        setFormData(prev => ({
            ...prev,
            [name]: value
        }))
    }

    return (
        <Container>
            <Row className="justify-content-left">
                <Col md={8} lg={6}>
                    <h1>Create Location</h1>
                    {error && (
                        <Alert 
                            variant="danger" 
                            onClose={() => setError(null)} 
                            dismissible
                        >
                            {error}
                        </Alert>
                    )}
                    <Form onSubmit={handleSubmit}>
                        <Form.Group className="mb-4">
                            <Form.Label>Name*</Form.Label>
                            <Form.Control
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                required
                                placeholder="Enter name"
                                autoComplete="off"
                                spellCheck="false"
                            />
                        </Form.Group>

                        <Form.Group className="mb-4">
                            <Form.Label>Description</Form.Label>
                            <Form.Control
                                type="text"
                                name="description"
                                value={formData.description}
                                onChange={handleChange}
                                placeholder="Enter description"
                                autoComplete="off"
                                spellCheck="false"
                            />
                        </Form.Group>

                        <Button 
                            variant="success" 
                            type="submit" 
                            className="me-2"
                        >
                            Create
                        </Button>
                        <Button 
                            variant="outline-primary" 
                            onClick={() => navigate(-1)}
                        >
                            <i className="fas fa-arrow-left me-2"></i>
                            Back to List
                        </Button>
                    </Form>
                </Col>
            </Row>
        </Container>
    )
}

export default LocationCreateScreen 